// extracted by mini-css-extract-plugin
module.exports = {"titleClass":"styles_titleClass__TPyeX","textClass":"styles_textClass__UYOOf","card":"styles_card__bEiAV"};